export const angleName = {
  EAST: 'EAST', // 0
  EAST_NORTH_EAST: 'EAST_NORTH_EAST', // 0 45
  NORTH_EAST: 'NORTH_EAST', // 45
  NORTH_NORTH_EAST: 'NORTH_NORTH_EAST', // 45 90
  NORTH: 'NORTH', // 90
  NORTH_NORTH_WEST: 'NORTH_NORTH_WEST', // 90 135
  NORTH_WEST: 'NORTH_WEST', // 135
  WEST_NORTH_WEST: 'WEST_NORTH_WEST', // 135 180
  WEST: 'WEST', // 180 || -180
  WEST_SOUTH_WEST: 'WEST_SOUTH_WEST', // -135 -180
  SOUTH_WEST: 'SOUTH_WEST', // -135
  SOUTH_SOUTH_WEST: 'SOUTH_SOUTH_WEST', // -90 -135
  SOUTH: 'SOUTH', // -90
  SOUTH_SOUTH_EAST: 'SOUTH_SOUTH_EAST', // -45 -90
  SOUTH_EAST: 'SOUTH_EAST', // -45
  EAST_SOUTH_EAST: 'EAST_SOUTH_EAST', // 0 -45
};

function direction(theta) {
  if (theta === 0) return angleName.EAST;
  if (0 < theta && theta < 45) return angleName.EAST_NORTH_EAST;
  if (theta === 45) return angleName.NORTH_EAST;
  if (45 < theta && theta < 90) return angleName.NORTH_NORTH_EAST;
  if (theta === 90) return angleName.NORTH;
  if (90 < theta && theta < 135) return angleName.NORTH_NORTH_WEST;
  if (theta === 135) return angleName.NORTH_WEST;
  if (135 < theta && theta < 180) return angleName.WEST_NORTH_WEST;
  if (theta === 180) return angleName.WEST;
  if (-180 < theta && theta < -135) return angleName.WEST_SOUTH_WEST;
  if (theta === -135) return angleName.SOUTH_WEST;
  if (-135 < theta && theta < -90) return angleName.SOUTH_SOUTH_WEST;
  if (theta === -90) return angleName.SOUTH;
  if (-90 < theta && theta < -45) return angleName.SOUTH_SOUTH_EAST;
  if (theta === -45) return angleName.SOUTH_EAST;
  if (-45 < theta && theta < 0) return angleName.EAST_SOUTH_EAST;
  return 'NO_ANGLE';
}

// 计算角度
export function angle(origin, destination) {
  var dx = destination.lng - origin.lng; // 经度
  var dy = destination.lat - origin.lat; // 纬度
  var theta = Math.atan2(dy, dx); // range (-PI, PI]
  theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  return direction(theta);
}
